import { render, staticRenderFns } from "./LibQuota.vue?vue&type=template&id=1335d45a&scoped=true"
import script from "./LibQuota.vue?vue&type=script&lang=js"
export * from "./LibQuota.vue?vue&type=script&lang=js"
import style0 from "./LibQuota.vue?vue&type=style&index=0&id=1335d45a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1335d45a",
  null
  
)

export default component.exports